'use strict'

var create = require('./util/create')

module.exports = create({
  space: 'xlink',
  transform: xlinkTransform,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

function xlinkTransform(_, prop) {
  return 'xlink:' + prop.slice(5).toLowerCase()
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/xlink.js
// module id = 200
// module chunks = 168707334958949